import { render, staticRenderFns } from "./IdentityValidation.vue?vue&type=template&id=0811f9a4&scoped=true&"
import script from "./IdentityValidation.vue?vue&type=script&lang=js&"
export * from "./IdentityValidation.vue?vue&type=script&lang=js&"
import style0 from "./IdentityValidation.vue?vue&type=style&index=0&id=0811f9a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0811f9a4",
  null
  
)

export default component.exports